/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

angular.module('common.model.geoarea', ['ngResource', 'common.helper']).factory('GeophicalArea', function ($resource, CONSTANTS) {
    return $resource(CONSTANTS.host + CONSTANTS.ws_context + '/ref/gear/groups/:id/memberships', {}, {
        queryMembership: {
            method: 'GET',
            isArray: false
        },
        find: {
            method: 'GET',
            isArray: false,
            url: '/arctictariff-public-web/service/api/geoArea/:id'
        },
        getCountriesOfOrigin: {
            method: 'GET',
            isArray: false,
            url: CONSTANTS.host + CONSTANTS.ws_context + '/ref/gear/countriesAndRegions/'
        },
        getCountriesRegionsAndGroups: {
            method: 'GET',
            isArray: false,
            url: CONSTANTS.host + CONSTANTS.ws_context + '/ref/gear/countriesRegionsAndGroups/'
        }

    });
}).service('GeographicalAreaModel', function(GeophicalArea, $q, CommonHelper){
    var model = this;
    model.queryMembershipByGroupId = function(origin, simulationDate){
        var deferred = $q.defer();
        GeophicalArea.queryMembership({id: origin, simulationdate: CommonHelper.getRestDateString(simulationDate)}, function (result) {
            deferred.resolve(result);
        }, function(error){
            deferred.reject(error);
        });
        return deferred.promise;
    };
    
    model.findGeographicalArea = function(id, simulationDate){
        var deferred = $q.defer();
        GeophicalArea.find({id: id, simulationDate: simulationDate}, function (result) {
            deferred.resolve(result);
        }, function(error){
            deferred.reject(error);
        });
        return deferred.promise;
    };

    model.getCountriesOfOrigin = function (simulationDate) {
        var deferred = $q.defer();
        GeophicalArea.getCountriesOfOrigin({simulationdate: CommonHelper.getRestDateString(simulationDate)}, function (result) {
            deferred.resolve(result);
        }, function(error){
            deferred.reject(error);
        });
        return deferred.promise;
    };

    model.getCountriesRegionsAndGroups = function (simulationDate) {
        var deferred = $q.defer();
        GeophicalArea.getCountriesRegionsAndGroups({simulationdate: CommonHelper.getRestDateString(simulationDate)}, function (result) {
            deferred.resolve(result);
        }, function(error){
            deferred.reject(error);
        });
        return deferred.promise;
    };

});



// WEBPACK FOOTER //
// ./app/common/model/taric/geo-area-model.js